export const DATA_CODE = {
  PD_010: 'PD_010',
};
